module.exports = __webpack_public_path__ + "media/src/application/media/svg/icon-32-ebf772a9cc52dfef788f104190e76800.svg";